<template>
    <div class="page-wrapper">
        <div class="cg-crumb">
            <span class="item">订单管理</span>
            <em class="gap">/</em>
            <span class="item">下单列表</span>
        </div>
        <div class="cg-main-title">
            下单列表
            <div class="link-wrap">
                <button class="cg-btn" @click="toListLock">锁仓列表</button>
                <button class="cg-btn red mgl-16" @click="toListOrder">下单列表</button>
                <button class="cg-btn mgl-16" @click="toListClear">清算列表</button>
            </div>
        </div>
        <div class="header-handle">
            <div class="cg-search-box">
                <el-input size="mini" placeholder="ID/商品名称/款号" prefix-icon="el-icon-search" v-model.trim="searchWords"
                    clearable>
                </el-input>
                <button class="cg-btn red" @click="searchHandle">搜索</button>
            </div>
            <!-- <div class="btns">
                <button class="cg-btn red" @click="toAddGoods">新增商品</button>
                <button class="cg-btn mgl-16" @click="exportItemInfo">下载表格</button>
            </div> -->
        </div>
        <div class="table-wrap">
            <el-table :data="tableData" v-loading="loading" size="small">
                <el-table-column align="center" label="序号" type="index" width="50" :index="indexMethod">
                </el-table-column>
                <el-table-column prop="order_number" label="下单订单号" width="100">
                </el-table-column>
                <el-table-column prop="productMainImageFile" label="图片" width="80">
                    <template slot-scope="scope">
                        <el-image style="width: 64px; height: 64px" :src="scope.row.productMainImageFile" fit="cover"
                            :preview-src-list="[scope.row.productMainImageFile]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="item_name" label="商品名称" width="110">
                </el-table-column>
                <el-table-column prop="styleNumber" label="款号" width="90">
                </el-table-column>
                <el-table-column prop="item_order_price" label="价格(元)" width="80">
                    <template slot-scope="scope">
                        {{scope.row.item_order_price | price}}
                    </template>
                </el-table-column>
                <el-table-column prop="supplierName" label="供应商" width="80">
                </el-table-column>
                <el-table-column prop="order_submit_time" label="下单时间" width="90">
                </el-table-column>
                <el-table-column prop="order_purchase_quantity" label="下单数" width="60">
                </el-table-column>
                <el-table-column prop="sumOrderReserveQuantity" label="锁仓数" width="60">
                </el-table-column>
                <el-table-column prop="sumEstablishQuantity" label="已核销" width="60">
                </el-table-column>
                <el-table-column
                    prop="needPay"
                    label="已出账单需支付(元)"
                    width="80"
                ></el-table-column>
         <!--       <el-table-column
                    prop="sumPay"
                    label="已确认累计支付额(元)"
                    width="80"
                >
                </el-table-column> -->
                <el-table-column
                    prop="amountToBeConfirmed"
                    label="待确认金额(元)"
                    width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="paidAmount"
                    label="已确认累计付款(元)"
                    width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="unpaidAmount"
                    label="已出账单欠款(元)"
                    width="80"
                ></el-table-column>
              <!--  <el-table-column
                    prop="debtMoney"
                    label="欠款(元)"
                    width="80"
                >
                </el-table-column> -->
                <el-table-column
                    prop="remainAmount"
                    label="剩余可申请额度(元)"
                    width="80"
                ></el-table-column>
                <el-table-column
                    prop="toBeReviewed"
                    label="待审核申请额(元)"
                    width="80"
                ></el-table-column>
                
                <el-table-column
                    prop="itemState"
                    label="下单状态"
                    width="120"  fixed="right"
                >
                    <template slot-scope="scope">
                        <template v-if="scope.row.liquidateState == '4'">
                            <el-tag type="success" size="medium">已转为清算</el-tag>
                        </template>
                        <template v-else>
                            <el-tag type="warning" size="medium">{{scope.row.status_pass}}</el-tag> <br>
                            <el-tag type="warning" size="medium" style="margin-top: 4px">{{scope.row.status_pay}}</el-tag>
                        </template>
                    </template>
                </el-table-column>
               
                <el-table-column label="操作" min-width="160" fixed="right">
                    <template slot-scope="scope">
                        <el-button class="cg-icon-btn" v-if="!(scope.row.liquidateState==4)&&(scope.row.remainAmount>0)&&(scope.row.status_pay=='从未付款')" @click="openApplyModal(scope.row)" type="text" size="small">申请平台打款</el-button>
                        <el-button class="cg-icon-btn" @click="toOrderDetail(scope.row)" type="text" size="small">查看</el-button>
                        <el-button class="cg-icon-btn" v-if=" !(scope.row.liquidateState==4)&&(scope.row.status_pass=='从未核销'||scope.row.status_pass=='部分核销') " @click="toOrderDetail(scope.row)" type="text" size="small">去核销</el-button>
                        <el-button class="cg-icon-btn" v-if=" !(scope.row.liquidateState==4)&&(scope.row.unpaidAmount>0)&&(scope.row.status_pay=='从未付款'||scope.row.status_pay=='部分付款') " @click="toOrderDetail(scope.row)" type="text" size="small">去付款</el-button>
                        <el-button class="cg-icon-btn" v-if="!(scope.row.liquidateState==4)" 
                        @click="openToClearModal(scope.row)" type="text" size="small">发起清算</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="cg-pagination-wrap">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[5, 10, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>

        </div>
        <el-dialog width="1100px"  center  :visible.sync="isShowGroupModal" :title="'该商品下共有'+groupModalTable.length+'条'+'下单记录，将会同时清算'" >
            <div class="clear-sure-top">
                <el-image
                    class="img"
                    :src="currentModalObj.productMainImageFile"
                    fit="cover"
                >
                </el-image>
                <div class="info">
                    <span>名称：{{currentModalObj.item_name}}</span> <br>
                    <span>款号：{{currentModalObj.item_style_number}}</span>
                </div>
            </div>
            <el-table :data="groupModalTable" size="small">
                <el-table-column property="order_number" label="下单订单号" width="160"></el-table-column>
                <el-table-column property="order_purchase_quantity" label="下单数量"  width="80"></el-table-column>
                <el-table-column property="item_order_price" label="核销价/元" width="85"></el-table-column>
                <el-table-column property="sumEstablishQuantity" label="已核销" width="100"></el-table-column>
                <el-table-column property="needPay" label="已出账单需支付" width="110"></el-table-column>
                <el-table-column property="sumPay" label="平台已确认金额" width="110"></el-table-column>
                <el-table-column property="amountToBeConfirmed" label="平台未确认金额" width="110"></el-table-column>
                <el-table-column property="unpaidAmount" label="已出账单欠款" width="100"></el-table-column>
                <el-table-column property="order_submit_time" label="下单时间" ></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                  <el-button @click="isShowGroupModal = false">取消</el-button>
                  <el-button type="primary" @click="startLiquidate">确定清算</el-button>
            </div>
        </el-dialog>
        <applymodal  v-show="isShowApplyModal" :info="currentApplyObj" @close="closeApplyModal" @success="closeApplyModalAndSuccess"></applymodal>
    </div>
</template>

<script>
    import {
        getPurchaseList,getOrderPurchaseList,launchLiquidate,checkPaymentStatus 
    } from '../../../api/dealer'
    import {
        mapGetters
    } from 'vuex'
    import {computeSub} from '../../../utils/tools'
    import applymodal from '../../../components/applymodal'
    export default {
        data() {
            return {
                loading: false,
                searchWords: '',
                tableData: [],

                // 分页
                pageSize: 10,
                total: 0,
                currentPage: 1,
                isShowGroupModal:false,
                groupModalTable:[],
                currentModalObj:{},
                
                isShowApplyModal:false,
                currentApplyObj:{},
            }
        },
        computed: {
            ...mapGetters(['userId'])
        },
        components:{
            applymodal
        },
        created() {
            console.log(this.$route.query);
        },
        watch: {
            '$route': {
                handler: function(route) {
                    this.pageSize = Number(this.$route.query.size) ? Number(this.$route.query.size) : 10
                    this.currentPage = Number(this.$route.query.page) ? Number(this.$route.query.page) : 1
                    this.searchWords = this.$route.query.search || ''
                    this.getOrderList();
                },
                immediate: true
            }
        },
        methods: {
            closeApplyModal(){
                this.isShowApplyModal=false
            },
            closeApplyModalAndSuccess(){
                this.isShowApplyModal=false
                //刷新页面
                this.getOrderList()
            },
            openApplyModal(list){
                console.log(list)
                let _this = this
                this.isShowApplyModal=true
                this.currentApplyObj={
                    itemName:list.productName,
                    supplierName:list.supplierName,
                    purchaseOrderId:list.order_id,
                    orderNumber_show:list.order_number,
                    toBeReviewed:list.toBeReviewed,
                    reviewed:list.reviewed,
                    requestAmount:list.requestAmount,
                    maxNumber:list.remainAmount
                    //toBeReviewed 待审核金额   reviewed 已审核金额   requestAmount 总共可申请金额    remainAmount 剩下可申请金额

                }
            },
            openToClearModal(list){
                console.log(list)
                let _this = this
                _this.currentModalObj=list
                let arg = {
                    "supplierUserId": _this.currentModalObj.supplier_user_id,
                    "dealerUserId": this.userId,
                    "itemId": _this.currentModalObj.itemId,
                    "orderSubmitType":'dealer'
                }
                getOrderPurchaseList(arg).then(res => {
                    // console.log(res)
                    if (res.errorCode == 200) {
                        _this.groupModalTable = res.data
                        _this.isShowGroupModal=true
                        // if(_this.groupModalTable.length>1){
                        //     _this.isShowGroupModal=true
                        // }else{
                        //     _this.startLiquidate()
                        // }
                    } else {
                        _this.groupModalTable = []
                    }
                })
            },
            initPage(){
                this.getOrderList()
                this.isShowGroupModal=false
                this.currentModalObj={}
                this.groupModalTable=[]
            },
            startLiquidate(){//去清算页
                let _this=this
                checkPaymentStatus({
                    "supplierUserId":_this.currentModalObj.supplier_user_id,
                    "dealerUserId":this.userId,
                    "itemId":_this.currentModalObj.itemId,
                }) .then(res =>{
                    console.log(res)
                    if(res.errorCode==200){
                        this.$confirm('您确定发起清算吗?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            launchLiquidate({
                                "supplierUserId":_this.currentModalObj.supplier_user_id,
                                "dealerUserId":this.userId,
                                "itemId":_this.currentModalObj.itemId,
                                "orderState":"2",
                                // "liquidateOrderId":"",
                                "orderSubmitType":"dealer"
                                
                            }).then(res => {
                                console.log(res)
                                if (res.errorCode == 200) {
                                    this.$message.success(res.errorMsg || '操作成功')
                                    this.initPage()
                                } else {
                                    this.$message.error(res.errorMsg || '操作失败')
                                }
                            }).catch(err => {
                                console.log(err)
                            })
                        })
                    }else{
                        // this.$message.error(res.errorMsg || '有确认的支付凭证，不能发起清算')
                        this.$message.error("有付款凭证未审核，请等待所有付款凭证审核完成后才能发起清算")
                    }
                    
                })
                 
                
                // this.$router.push('/dealer/order/liquidation?orderId=' + this.currentModalObj.order_id)
            },
            getOrderList() {
                this.loading = true
                getPurchaseList({
                    "supplierUserId": "",
                    "dealerUserId": this.userId,
                    "page": this.currentPage,
                    "num": this.pageSize,
                    "fuzzyQuery": this.searchWords,
                }).then(res => {
                    this.loading = false
                    console.log('getOrderList', res)
                    if (res.errorCode == 200) {
                        this.tableData = res.data.orderList.map(item => {
                            let status_pass = ''
                            let status_pay = ''
                            
                            if (!item.sumEstablishQuantity) {status_pass = '从未核销'}
                            else if (item.sumEstablishQuantity < item.order_purchase_quantity) {status_pass = '部分核销'}
                            else if (item.sumEstablishQuantity == item.order_purchase_quantity) {status_pass = '全部核销'}
                            
                            if (!item.paidAmount) {status_pay = '从未付款'}
                            else if (item.unpaidAmount > 0) {status_pay = '部分付款'}
                            else if (item.unpaidAmount == 0) {status_pay = '全部付款'}
                            let debtMoney =computeSub(item.needPay - item.sumPay) 
                            return {
                                ...item,
                                status_pass,
                                status_pay,
                                debtMoney,
                                productMainImageFile: process.env.VUE_APP_IMG_PREV + item.productMainImageFile
                            }
                        })
                        this.total = parseInt(res.data.totalCount)
                    } else {
                        this.$message.error(res.errorMsg || '获取列表数据失败')
                    }
                }).catch(err => {
                    this.loading = false
                    console.log(err)
                })
            },
            searchHandle() {
                this.currentPage = 1
                this.curRoutePush()
            },

            toOrderDetail(row) {
                this.$router.push('/dealer/order/detail-take?orderNumber=' + row.order_number)
            },

            indexMethod(index) {
                return this.total - this.pageSize * (this.currentPage - 1) - index;
            },
            handleSizeChange(val) {
                this.pageSize = val
                this.currentPage = 1
                this.curRoutePush()
            },
            curRoutePush() {
                this.$router.push('/dealer/order/list-take?search=' + this.searchWords +
                    '&page=' + this.currentPage +
                    '&size=' + this.pageSize).catch(err => {
                    err
                })
            },
            handleCurrentChange(val) {
                this.currentPage = val
                this.curRoutePush()
            },
            toListLock() {
                this.$router.push('/dealer/order/list-lock')
            },
            toListOrder() {
                this.$router.push('/dealer/order/list-take')
            },
            toListClear() {
                this.$router.push('/dealer/order/list-clear')
            },
        },
    }
</script>

<style lang="scss" scoped>
    .page-wrapper {
        padding: 24px 24px;
        min-width: 900px;
    }

    .header-handle {
        margin-top: 24px;
        padding: 20px 24px;
        height: 28px;
        background: #fff;

        .cg-search-box {
            float: left;
        }

        .btns {
            float: right;
        }
    }

    .table-wrap {
        margin-top: 8px
    }

    .el-image {
        display: block;
    }
    .clear-sure-top {
        height: 64px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e6e6e6;
        position: relative;
        .img {width: 64px; height: 64px; float: left; border: 1px solid #eee}
        .info {padding-left: 80px;}
        .count {position: absolute; right: 0; bottom: 10px; font-size: 12px; color: #333; line-height: 1;}
    }
</style>
